module.exports = __webpack_public_path__ + "img/btn-activity-over.4e759b1a.png";